<template>
  <v-dialog v-model="modal"  max-width="500px"  persistent>
    <v-card width="100%">
      <template>
        <v-card-text>
          <branch-office-form
              v-if="showBranchOfficeForm"
              ref="branchOfficeForm"
              class="mt-3"
              strict-mode
              :default="item"
              @change="branchOffice = $event"
              @change:validation="isBranchOfficeValid = $event" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="hide" :disabled="editing">Cancelar</v-btn>
          <v-btn
              color="primary"
              :disabled="!isBranchOfficeValid"
              :loading="editing"
              @click="submitEditedOffice"
          >Guardar</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>

</template>
<script>

import {ApiUtils} from '../../../utils/ApiUtils'

import BranchOfficeForm from "./BranchOfficeForm";
import KimsaConfirm from '../../../components/common/KimsaConfirm'

export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  },
  components: {
    BranchOfficeForm,
    KimsaConfirm,
    CardListado: () => import('@/components/providers/panel/CardListado'),
    FormUsuario: () => import('@/components/providers/panel/FormInvitacionUsuario'),
    ListUsers: () => import('@/components/providers/panel/ListUsers'),
    ProviderTitle: () => import('@/components/providers/panel/ProviderTitle'),
    ProviderData: () => import('@/components/providers/panel/ProviderData'),
    FormSucursal: () => import('@/components/providers/panel/FormAnadirSucursal'),
  },
  data() {
    return {
      modal: false,
      comuna: null,
      editing: false,
      item: {},
      commune: {},
      selected: {},
      isBranchOfficeValid: false,
      showBranchOfficeForm: false,
      branchOffice: null
    }
  },
mounted(){
},
watch:{},
  computed: {
    loading() {
      return this.$store.getters['branches/loading']
    }
  },
  methods: {
    show(item){
      const vm = this
      vm.item = item
      vm.showBranchOfficeForm = true
      vm.modal = true
    },
    hide(){
      const vm = this
      vm.item = {}
      vm.modal = false
      setTimeout(function(){
        vm.showBranchOfficeForm = false
      }, 200)
    },
    async submitEditedOffice() {
      const vm = this
      if(!vm.isBranchOfficeValid) return
      vm.editing = true
      const office = {
        id: vm.item.id,
        ...vm.branchOffice
      }
      const edited = await vm.$store.dispatch('branches/editBranch', office)
      if (edited){
        vm.item = {}
        vm.$emit('cerrar')
        await ApiUtils.fetchMe()
        vm.$emit('saved')
        vm.hide()
      }
      vm.editing = false
    },
    cancelEdition() {
      this.$emit('cerrar')
    },
    async deleteBranch() {
      const deleted = await this.$store.dispatch('branches/deleteBranch', this.item)

      if (deleted){
        this.$emit('cerrar')
      }
    }
  }
}
</script>
<style scoped>
h2 {
  font-size: 25px;
}
.main {
  background-color: rgb(85, 84, 85);
  color: #fff;
  padding: 0 7px;
  border-radius: 25px;
  margin-right: 5px;
  font-size: 11px;
}
.casa-matriz {
  background-color: red;
  padding: 3px 8px;
  border-radius: 25px;
  color: #fff;
}
</style>
